import styled from 'styled-components';

export const InputContainer = styled.div`
  margin: 10px 0;
  height: 50px;
`;
